<template>
  <div class="document-list-block">
    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon3.png" />
        <span style="flex-grow: 1">我的参会</span>
        <span v-if="activeName === 'file'" style="font-size: 14px"
          >资料分类：</span
        >
        <el-select
          v-if="activeName === 'file'"
          v-model="pageparmFile.file_type"
          placeholder="请选择标签"
          size="mini"
          @change="tagsChange"
        >
          <el-option
            v-for="item in fileTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <!-- <span
          v-if="activeName === 'file'"
          style="font-size: 14px; margin-left: 12px"
          >标签分类：</span
        >
        <el-select
          v-if="activeName === 'file'"
          v-model="pageparm.tag_name"
          placeholder="请选择标签"
          size="mini"
          @change="tagsChange"
        >
          <el-option
            v-for="item in tagOptions"
            :key="item.tag_name"
            :label="item.tag_name"
            :value="item.tag_name"
          >
          </el-option>
        </el-select> -->
        <el-button
          v-if="activeName === 'file'"
          @click="toOrder"
          icon="el-icon-refresh-left"
          size="mini"
          type="primary"
          style="font-size: 14px; margin-left: 12px"
          >返回</el-button
        >
      </div>

      <div class="info">
        <el-alert
          v-if="!isLogin"
          :closable="false"
          show-icon
          title="友情提示 Important Notice"
          type="warning"
        >
          <div class="flex">
            <span
              >为更好地为您提供服务，请首先进行注册/登录，本系统仅登录用户方可下载相关资料，建议您先注册/登录再进行相关资料下载。</span
            >
            <span @click="toLogin" class="tel">立即登录 Login</span>
          </div>
        </el-alert>

        <el-table
          v-show="activeName === 'order'"
          :empty-text="
            !isLogin
              ? '请登录后查看相关内容'
              : '暂无已购买资料，请您前往资料购买页面进行购买！'
          "
          :data="tableData"
          default-expand-all
          v-loading="tableLoading"
          :row-class-name="getRowClass"
        >
          <el-table-column prop="status" type="expand">
            <template slot-scope="props">
              <!-- 订单状态，0，待付款；1，待审核；2，驳回；3，已完成；4，已废弃 -->

              <!-- 付款凭证被驳回-->
              <el-alert
                :closable="false"
                show-icon
                title="提示"
                type="warning"
                v-if="props.row.status == 2"
              >
                <div class="flex">
                  <div class="alert-text">
                    <div class="alert-import">
                      您上传的付款凭证经后台审核不通过，请重新上传。
                      <span
                        @click="textInfoDialogVisible = true"
                        class="color-blue"
                        >《科研圈内人服务协议》</span
                      >
                    </div>
                  </div>
                  <div class="btn-operation">
                    <!--付款凭证驳回后，重新上传成功汇款凭证-->
                    <el-button
                      @click="confirmQuotationClick(props.row)"
                      icon="el-icon-upload"
                      size="mini"
                      type="primary"
                      >上传成功汇款凭证</el-button
                    >
                  </div>
                </div>
              </el-alert>

              <div class="download" v-if="props.row.status == 0">
                <div class="flex">
                  <!-- <el-button
                    @click="downloadInvoice(props.row)"
                    icon="el-icon-download"
                    size="mini"
                    type="primary"
                    >下载</el-button
                  > -->
                  <el-button
                    @click="confirmQuotationClick(props.row)"
                    icon="el-icon-upload"
                    size="mini"
                    type="primary"
                    >上传成功汇款凭证</el-button
                  >
                </div>
              </div>

              <!-- <div class="download" v-if="props.row.status == 3">
                <div v-for="item in props.row.file_info" :key="item.id">
                  <div class="more-line">
                    <span>{{ item.title }}</span>
                    <el-button
                      type="primary"
                      @click="downloadDocument(item.url)"
                      icon="el-icon-view"
                      size="mini"
                      circle
                    ></el-button>
                  </div>
                </div>
              </div> -->
            </template>
          </el-table-column>
          <el-table-column label="订单编号" prop="order_id"></el-table-column>
          <el-table-column label="活动名称">
            <template slot-scope="scope">
              <span>{{ scope.row.activity_info.activity_name }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="价格" prop="tag_price"></el-table-column> -->
          <!-- <el-table-column label="标签分类">
            <template slot-scope="scope">
              <span>{{ scope.row.tag_name }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="时间节点">
            <template slot-scope="scope">
              <span>{{ scope.row.activity_info.activity_date }}</span>
            </template>
          </el-table-column>
          <el-table-column label="介绍">
            <template slot-scope="scope">
              <el-link
                type="primary"
                :href="scope.row.activity_info.activity_remarks"
                target="_blank"
                >链接跳转</el-link
              >
            </template>
          </el-table-column>
          <el-table-column label="订单状态" width="110">
            <template slot-scope="scope">
              <!-- 订单状态，0，待付款；1，待审核；2，驳回；3，已完成；4，已废弃 -->
              <span
                :class="{
                  'color-blue': true,
                  'color-red':
                    scope.row.status == '2' || scope.row.status == '4',
                  'color-green': scope.row.status == '3',
                  'color-orange': scope.row.status == '1'
                }"
                >{{ scope.row.status | orderStatus }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="订单金额">
            <template slot-scope="props">
              <span
                :class="{
                  'color-orange': true
                }"
                >{{ props.row.tag_price }}</span
              >
            </template>
          </el-table-column>
          <el-table-column width="150" label="提交时间">
            <template slot-scope="props">{{
              props.row.creation_time | dateFormat('YYYY-MM-DD HH:mm')
            }}</template>
          </el-table-column>
          <el-table-column label="参会密钥">
            <template slot-scope="scope">
              <span>{{ scope.row.invite_code }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="65">
            <template slot-scope="scope">
              <el-button
                :disabled="scope.row.status != '3'"
                type="primary"
                @click="toFileList(scope.row)"
                icon="el-icon-view"
                size="mini"
                circle
              ></el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-table
          v-show="activeName === 'file'"
          :empty-text="
            !isLogin
              ? '请登录后查看相关内容'
              : '若您已完成报名，待会议结束后，可在此处查看全部会议资料和全程录屏回放。'
          "
          :data="tableDataFile"
          default-expand-all
          v-loading="tableLoading"
        >
          <el-table-column label="资料名称">
            <template slot-scope="scope">
              <span>{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="标签分类">
            <template slot-scope="scope">
              <span>{{ scope.row.tag }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button
                type="primary"
                @click="download(scope.row)"
                icon="el-icon-view"
                size="mini"
                circle
              ></el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页组件 -- 订单列表 -->
        <NewPagination
          v-if="activeName === 'order'"
          :current-page.sync="pageparm.page"
          :limit.sync="pageparm.size"
          :total="pageparm.total"
          @pagination="handleCurrentChange"
        />

        <!-- 分页组件 -- 文件列表 -->
        <NewPagination
          v-else
          :current-page.sync="pageparmFile.page"
          :limit.sync="pageparmFile.size"
          :total="pageparmFile.total"
          @pagination="handleCurrentChangeFile"
        />
      </div>
    </div>

    <!--隐私条款、服务条款-->
    <TextInfo
      v-if="textInfoDialogVisible"
      :dialogVisible.sync="textInfoDialogVisible"
      :type="textInfoType"
    />

    <!--上传成功汇款凭证-->
    <ConfirmQuotation
      v-if="confirmQuotationDialogVisible"
      :checkedInfo="checkedInfo"
      :dialogVisible.sync="confirmQuotationDialogVisible"
      @getList="getListByPage"
    />
  </div>
</template>

<script>
/**
 * @description 已购买资料
 */
import * as api from '@/api/user'
// 封装的分页组件
import NewPagination from '@/components/Pagination/index'
// 上传成功汇款凭证
import ConfirmQuotation from '@/views/order/activity/confirm_quotation'
// 隐私条款、服务条款 展示隐藏
import TextInfo from '@/components/TextInfo'

export default {
  name: 'AlreadyPaymentInformationList',
  components: {
    NewPagination,
    ConfirmQuotation,
    TextInfo
  },
  data() {
    return {
      total: 0, // 订单总量
      // 分页参数
      pageparm: {
        page: 1,
        size: 10,
        total: 0,
        file_type: 3,
        tag_name: '',
        tag_id: ''
      },
      // 分页参数
      pageparmFile: {
        page: 1,
        size: 10,
        total: 0,
        file_type: 3,
        tag_name: '',
        tag_id: ''
      },
      tableData: [],
      tableDataFile: [],
      tableLoading: false,
      isLogin: true, // 是否已经登陆
      checkedInfo: null, // 选中的订单信息
      activeName: 'order', // 外层order， 内层file
      tagOptions: [], // 标签分类：
      fileTypeOptions: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 1,
          label: '普通文件'
        },
        {
          value: 2,
          label: '视频'
        },
        {
          value: 3,
          label: '音频'
        }
      ], // 1是普通文件，2是视频， 3音频

      confirmQuotationDialogVisible: false, // 上传成功汇款凭证
      textInfoDialogVisible: false, // 隐私条款、服务条款 展示隐藏
      textInfoType: 'service' // 隐私条款（privacy）、服务条款（service） 展示隐藏
    }
  },
  // 计算属性
  computed: {
    userInfoWatch() {
      return this.$store.state.user.userName
    }
  },
  // 监听
  watch: {
    userInfoWatch(curVal, oldVal) {
      this.isLogin = !!this.$store.state.user.userInfo
      this.getPublicInformationTagList()
      this.getListByPage()
    }
  },
  created() {
    if (
      !localStorage.getItem('userInfo') ||
      localStorage.getItem('userInfo') == 'null'
    ) {
      this.isLogin = false
      this.toLogin()
    } else {
      this.getPublicInformationTagList()
      this.getListByPage()
    }
  },
  methods: {
    /**
     * @description 点击去登录
     */
    toLogin() {
      this.$store.dispatch('user/toLogin', { toggle: true })
    },

    /**
     * @description 前往file页面
     */
    toFileList(_item) {
      const _this = this
      if (
        !localStorage.getItem('userInfo') ||
        localStorage.getItem('userInfo') == 'null'
      ) {
        _this.toLogin()
      } else {
        _this.activeName = 'file'
        _this.checkedInfo = _item

        // 查看file页面数据
        _this.pageparmFile.page = 1
        _this.pageparmFile.tag_name = _item.tag_name
        _this.pageparmFile.tag_id = _item.tag_id
        _this.pageparmFile.file_type = ''
        this.getTagFileList()
      }
    },

    /**
     * @description 前往order页面
     */
    toOrder() {
      const _this = this
      if (
        !localStorage.getItem('userInfo') ||
        localStorage.getItem('userInfo') == 'null'
      ) {
        _this.toLogin()
      } else {
        _this.activeName = 'order'

        // 查看order页面数据
        _this.pageparm.page = 1
        this.getListByPage()
      }
    },

    /**
     * @description 下载
     */
    download(_item) {
      const _this = this
      if (
        !localStorage.getItem('userInfo') ||
        localStorage.getItem('userInfo') == 'null'
      ) {
        _this.toLogin()
      } else {
        window.open(
          _item.file_name
          // `${_this.$store.state.user.urlLink}get_file?path_name=${_item.file_name}`
        )
      }
    },

    /**
     * @description 获取已完成订单分页列表
     */
    getListByPage() {
      const _this = this
      _this.tableLoading = true
      const _param = {
        page: _this.pageparm.page,
        limit: _this.pageparm.size,
        type: 2
      }

      api.getDataOrderList(_param).then((res) => {
        const data = res.data
        _this.tableLoading = false
        _this.tableData = data.list
        _this.pageparm.total = data.count
      })
      // .catch(err => {
      // })
    },

    /**
     * @description 获取标签数据
     */
    getPublicInformationTagList() {
      const _this = this
      const _param = {
        page: 1,
        limit: 9999
      }
      api.publicInformationTagList(_param).then((res) => {
        const data = res.data
        // console.log('data', data)
        _this.tagOptions = data.list
      })
    },

    /**
     * @description 页码切换
     * @param {val} 页码
     */
    handleCurrentChange(val) {
      const _this = this
      _this.pageparm.page = val.page
      _this.pageparm.size = val.limit
      _this.getListByPage()
    },

    /**
     * @description 标签change筛选
     */
    tagsChange() {
      this.pageparmFile.page = 1
      this.getTagFileList()
    },

    /**
     * @description 获取所有订单内的文件
     */
    getTagFileList() {
      const _this = this
      _this.tableLoading = true
      const _param = {
        page: _this.pageparmFile.page,
        limit: _this.pageparmFile.size,
        file_type: _this.pageparmFile.file_type,
        tag_name: _this.pageparmFile.tag_name,
        tag_id: _this.pageparmFile.tag_id
      }

      api.ajaxTagFileList(_param).then((res) => {
        const data = res.data
        _this.tableLoading = false
        _this.tableDataFile = data.list
        console.log('_this.tableDataFile', _this.tableDataFile)
        _this.pageparmFile.total = data.count
      })
      // .catch(err => {
      // })
    },

    /**
     * @description 页码切换
     * @param {val} 页码
     */
    handleCurrentChangeFile(val) {
      const _this = this
      _this.pageparmFile.page = val.page
      _this.pageparmFile.size = val.limit
      _this.getTagFileList()
    },

    /**
     * @description 订单相关
     */
    /**
     * @description 上传成功汇款凭证点击
     */
    confirmQuotationClick(_item) {
      this.checkedInfo = _item
      this.confirmQuotationDialogVisible = true
    },

    /**
     * @description 判断当前订单是否是展示下啦，待缴费、缴费驳回
     * @param {status} 订单状态，0，待付款；1，待审核；2，驳回；3，已完成；4，已废弃
     * @param {isHide} 需要隐藏的状态
     */
    getRowClass(_item) {
      let isHide =
        _item.row.status == '1' ||
        _item.row.status == '3' ||
        _item.row.status == '4'
      if (isHide) {
        return 'row-expand-cover'
      }
    }

    // /**
    //  * @description 下载
    //  * @param {}
    //  */
    // downloadInvoice(_item) {
    //   window.open(_item.invoice_img)
    //   // _data.serviced_doc_url.map((item) => {
    //   //   window.open(`${item}`)
    //   // })
    // },
  },
  filters: {
    /**
     * @description 订单状态的转换
     * @param {status} 订单状态，0，待付款；1，待审核；2，驳回；3，已完成；4，已废弃
     */
    orderStatus(val) {
      let formatVal = ''
      switch (val) {
        case 0:
          formatVal = '待付款'
          break
        case 1:
          formatVal = '待审核'
          break
        case 2:
          formatVal = '驳回'
          break
        case 3:
          formatVal = '已完成'
          break
        case 4:
          formatVal = '已废弃'
          break
        default:
          formatVal = ''
          break
      }
      return formatVal
    }
  }
}
</script>
<style lang="scss" scoped>
.document-list-block {
  .card-block {
    padding: 20px;
    margin: 0 0 40px 0;
    background: #ffffff;
    border: 1px solid #dfdfdf;
    -moz-box-shadow: 15px 15px 0 #dddddd; /* 老的 Firefox */
    box-shadow: 15px 15px 0 #dddddd;

    .title {
      display: flex;
      align-items: center;
      font-size: 24px;
      padding: 0 20px 20px 20px;
      border-bottom: 1px solid #dcdfe6;

      img {
        display: block;
        width: 30px;
        margin: 0 10px 0 0;
      }
    }

    .info {
      padding: 0;

      /deep/.el-table {
        margin-top: 20px;

        th {
          font-size: 19px;
        }

        a {
          color: $colorNormal;
        }

        .row-expand-cover .cell .el-table__expand-icon {
          display: none;
        }

        .el-alert__content {
          width: 100%;
        }

        .flex {
          display: flex;
          align-items: center;
          justify-content: space-between;
          // border-bottom: 1px solid #EBEEF5;
          // padding: 10px 0;
        }

        .download {
          border-bottom: 1px solid #ebeef5;
          padding: 10px 3px;

          .flex {
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }

          p {
            margin: 5px 0 0 0;

            span {
              color: $colorNormal;
              cursor: pointer;
              text-decoration: underline;
            }
          }
        }

        .el-table__expanded-cell[class*='cell'] {
          padding: 0;
          border-bottom: 0;
        }

        p {
          margin: 0;
        }

        .alert-text {
          width: 680px;

          // .alert-import {
          //   font-weight: bold;
          //   font-size: 14px;
          // }

          .remarks {
            color: #0099ff;
          }
        }

        .more-line {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px dashed #ededed;
          padding: 5px 15px;
          // margin-bottom: 10px;
        }

        .more-line {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #ededed;
          padding: 10px 15px;
          margin-bottom: 10px;
        }

        .color-blue {
          color: $colorNormal;
        }

        .color-red {
          color: #e30846;
        }

        .color-green {
          color: #57b99d;
        }

        .color-orange {
          color: #ea870f;
        }
      }

      .pagination-container {
        text-align: right;
      }

      /deep/.el-alert {
        margin: 0 0 15px 0;
        .el-alert__content {
          width: 100%;
        }

        .el-alert__title {
          font-size: 16px;
        }

        .flex {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
        }

        .tel {
          cursor: pointer;
          display: inline-block;
          width: 180px;
          height: 36px;
          line-height: 36px;
          border-radius: 3px;
          text-align: center;
          color: #ffffff;
          background: #ea870f;
          margin-top: -20px;
        }
      }
    }
  }
}
</style>